/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from '../../../utils/object';

const thirdPartyTypeName = {
    VC: 'VISA CHECKOUT',
    MP: 'MASTER PASS',
    CP: 'CHASE PAY',
    AM: 'AMEX Express',
    AP: 'Apple Pay',
};

class PaymentMethod extends React.PureComponent {
    render() {
        const {
            data: {
                cardType, cardNumber, thirdPartyType, giftCardPayments,
            },
        } = this.props;

        let paymentType = 'Credit Card';
        if (thirdPartyType) {
            paymentType = thirdPartyTypeName[thirdPartyType] || thirdPartyType;
        } else if (cardType) {
            paymentType = cardType;
        } else if (cardNumber) {
            paymentType = 'Credit Card';
        } else if (isEmpty(giftCardPayments)) {
            paymentType = 'Paypal';
        } else {
            paymentType = 'Gift Card';
        }

        return (
            <>
                <h2 className="gray-color">
                    Payment Method:{' '}
                    <span className="normal body-color">{paymentType}</span>
                </h2>
                {cardNumber ? (
                    <div>
                        <span className="uppercase gray-color bold">
                            CARD #:{' '}
                        </span>
                        {cardNumber.replace(/\*/g, '\u2022')}
                    </div>
                ) : (
                    ''
                )}
            </>
        );
    }
}

PaymentMethod.propTypes = {
    data: PropTypes.object.isRequired,
};

export default PaymentMethod;
